function buildVOCFromLiveStats(dataArr) {
  let result = []
  let previousValidValues = {
    vocIndex: null
  }

  if (!dataArr || !dataArr.length) {
    return []
  }
  
  for (let i = 0; i < dataArr.length; i++) {
    let relevantDataArr = []
    relevantDataArr.push(dataArr[i].datetime) // Index 0 will hold datetime

    // VOC Index from sen5x
    let vocIndex = parseFloat(dataArr[i].tstat_read_data.sen5x?.vox_index || 0)
    if (vocIndex === 0 && previousValidValues.vocIndex !== null) {
      vocIndex = previousValidValues.vocIndex
    }
    if (vocIndex !== 0) {
      previousValidValues.vocIndex = vocIndex
    }
    relevantDataArr.push(vocIndex)

    result.push(relevantDataArr)
  }

  return result
}

function formatVOCData(dataArr) {
  const chartData = dataArr.map((dataItem) => {
    return [
      new Date(dataItem[0]),           // Datetime
      dataItem[1]           // VOC Index
    ]
  })

  return chartData
}

export {
  buildVOCFromLiveStats,
  formatVOCData
}